export default __webpack_public_path__ + "static/media/error404.b1711932.png";